module.exports = __webpack_public_path__ + "ProximaNova-SemiboldIt.1822ec898c93666f88765f6364372855.woff2";